export default [
  { key: "{{d.comum.dataAtual}}", description: "Data atual (curta)" },
  { key: "{{d.comum.dataAtualExtenso}}", description: "Data atual por extenso" },
  { key: "{{d.comum.horaAtual}}", description: "Hora atual" },

  { key: "{{d.tarefa.titulo}}", description: "Título da tarefa" },
  { key: "{{d.tarefa.descricao}}", description: "Descrição da tarefa" },
  { key: "{{d.tarefa.status}}", description: "Status da tarefa" },
  { key: "{{d.tarefa.prioridade}}", description: "Prioridade da tarefa" },
  { key: "{{d.tarefa.dataPrazo}}", description: "Data de prazo da tarefa" },
  { key: "{{d.tarefa.horaPrazo}}", description: "Hora de prazo da tarefa" },
  { key: "{{d.tarefa.dataInicio}}", description: "Data de início da tarefa" },
  { key: "{{d.tarefa.obs}}", description: "Observação da tarefa" },

  { key: "{{d.tarefa.responsavel.nome}}", description: "Nome do responsável" },
  { key: "{{d.tarefa.responsavel.email}}", description: "E-mail do responsável" },
  { key: "{{d.tarefa.responsavel.celular}}", description: "Celular do responsável" },

  { key: "{{d.tarefa.solicitante.nome}}", description: "Nome do solicitante" },
  { key: "{{d.tarefa.solicitante.email}}", description: "E-mail do solicitante" },
];

